import { render, staticRenderFns } from "./BasePrivate.vue?vue&type=template&id=2d7048e6&"
import script from "./BasePrivate.vue?vue&type=script&lang=js&"
export * from "./BasePrivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports